import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoRogalandPrimaerBokmaalNegativPdf,
  LogoRogalandPrimaerBokmaalNegativPng,
  LogoRogalandPrimaerBokmaalNegativSvg,
  LogoRogalandPrimaerBokmaalPositivPdf,
  LogoRogalandPrimaerBokmaalPositivPng,
  LogoRogalandPrimaerBokmaalPositivSvg,
  LogoRogalandPrimaerBokmaalEngelskNegativPdf,
  LogoRogalandPrimaerBokmaalEngelskNegativPng,
  LogoRogalandPrimaerBokmaalEngelskNegativSvg,
  LogoRogalandPrimaerBokmaalEngelskPositivPdf,
  LogoRogalandPrimaerBokmaalEngelskPositivPng,
  LogoRogalandPrimaerBokmaalEngelskPositivSvg,
  LogoRogalandPrimaerNynorskNegativPdf,
  LogoRogalandPrimaerNynorskNegativPng,
  LogoRogalandPrimaerNynorskNegativSvg,
  LogoRogalandPrimaerNynorskPositivPdf,
  LogoRogalandPrimaerNynorskPositivPng,
  LogoRogalandPrimaerNynorskPositivSvg,
  LogoRogalandPrimaerNynorskEngelskNegativPdf,
  LogoRogalandPrimaerNynorskEngelskNegativPng,
  LogoRogalandPrimaerNynorskEngelskNegativSvg,
  LogoRogalandPrimaerNynorskEngelskPositivPdf,
  LogoRogalandPrimaerNynorskEngelskPositivPng,
  LogoRogalandPrimaerNynorskEngelskPositivSvg,
  LogoRogalandSekundaerBokmaalNegativPdf,
  LogoRogalandSekundaerBokmaalNegativPng,
  LogoRogalandSekundaerBokmaalNegativSvg,
  LogoRogalandSekundaerBokmaalPositivPdf,
  LogoRogalandSekundaerBokmaalPositivPng,
  LogoRogalandSekundaerBokmaalPositivSvg,
  LogoRogalandSekundaerBokmaalEngelskNegativPdf,
  LogoRogalandSekundaerBokmaalEngelskNegativPng,
  LogoRogalandSekundaerBokmaalEngelskNegativSvg,
  LogoRogalandSekundaerBokmaalEngelskPositivPdf,
  LogoRogalandSekundaerBokmaalEngelskPositivPng,
  LogoRogalandSekundaerBokmaalEngelskPositivSvg,
  LogoRogalandSekundaerNynorskNegativPdf,
  LogoRogalandSekundaerNynorskNegativPng,
  LogoRogalandSekundaerNynorskNegativSvg,
  LogoRogalandSekundaerNynorskPositivPdf,
  LogoRogalandSekundaerNynorskPositivPng,
  LogoRogalandSekundaerNynorskPositivSvg,
  LogoRogalandSekundaerNynorskEngelskNegativPdf,
  LogoRogalandSekundaerNynorskEngelskNegativPng,
  LogoRogalandSekundaerNynorskEngelskNegativSvg,
  LogoRogalandSekundaerNynorskEngelskPositivPdf,
  LogoRogalandSekundaerNynorskEngelskPositivPng,
  LogoRogalandSekundaerNynorskEngelskPositivSvg,
  LogoRogalandSentrertBokmaalNegativPdf,
  LogoRogalandSentrertBokmaalNegativPng,
  LogoRogalandSentrertBokmaalNegativSvg,
  LogoRogalandSentrertBokmaalPositivPdf,
  LogoRogalandSentrertBokmaalPositivPng,
  LogoRogalandSentrertBokmaalPositivSvg,
  LogoRogalandSentrertBokmaalEngelskNegativPdf,
  LogoRogalandSentrertBokmaalEngelskNegativPng,
  LogoRogalandSentrertBokmaalEngelskNegativSvg,
  LogoRogalandSentrertBokmaalEngelskPositivPdf,
  LogoRogalandSentrertBokmaalEngelskPositivPng,
  LogoRogalandSentrertBokmaalEngelskPositivSvg,
  LogoRogalandSentrertNynorskNegativPdf,
  LogoRogalandSentrertNynorskNegativPng,
  LogoRogalandSentrertNynorskNegativSvg,
  LogoRogalandSentrertNynorskPositivPdf,
  LogoRogalandSentrertNynorskPositivPng,
  LogoRogalandSentrertNynorskPositivSvg,
  LogoRogalandSentrertNynorskEngelskNegativPdf,
  LogoRogalandSentrertNynorskEngelskNegativPng,
  LogoRogalandSentrertNynorskEngelskNegativSvg,
  LogoRogalandSentrertNynorskEngelskPositivPdf,
  LogoRogalandSentrertNynorskEngelskPositivPng,
  LogoRogalandSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Rogaland/exportRogaland.js";

export default function RogalandPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Rogaland"
          lead="Alle logoer for Rogaland i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                      logoUrl={LogoRogalandPrimaerBokmaalPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, bokmål"
                      text="Bokmål"
                      blackSvg={LogoRogalandPrimaerBokmaalPositivSvg}
                      blackPng={LogoRogalandPrimaerBokmaalPositivPng}
                      blackPdf={LogoRogalandPrimaerBokmaalPositivPdf}
                      whiteSvg={LogoRogalandPrimaerBokmaalNegativSvg}
                      whitePng={LogoRogalandPrimaerBokmaalNegativPng}
                      whitePdf={LogoRogalandPrimaerBokmaalNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandPrimaerBokmaalEngelskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, bokmål + engelsk"
                      text="Bokmål + engelsk"
                      blackSvg={LogoRogalandPrimaerBokmaalEngelskPositivSvg}
                      blackPng={LogoRogalandPrimaerBokmaalEngelskPositivPng}
                      blackPdf={LogoRogalandPrimaerBokmaalEngelskPositivPdf}
                      whiteSvg={LogoRogalandPrimaerBokmaalEngelskNegativSvg}
                      whitePng={LogoRogalandPrimaerBokmaalEngelskNegativPng}
                      whitePdf={LogoRogalandPrimaerBokmaalEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandPrimaerNynorskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, nynorsk"
                      text="Nynorsk"
                      blackSvg={LogoRogalandPrimaerNynorskPositivSvg}
                      blackPng={LogoRogalandPrimaerNynorskPositivPng}
                      blackPdf={LogoRogalandPrimaerNynorskPositivPdf}
                      whiteSvg={LogoRogalandPrimaerNynorskNegativSvg}
                      whitePng={LogoRogalandPrimaerNynorskNegativPng}
                      whitePdf={LogoRogalandPrimaerNynorskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandPrimaerNynorskEngelskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, nynorsk + engelsk"
                      text="Nynorsk + engelsk"
                      blackSvg={LogoRogalandPrimaerNynorskEngelskPositivSvg}
                      blackPng={LogoRogalandPrimaerNynorskEngelskPositivPng}
                      blackPdf={LogoRogalandPrimaerNynorskEngelskPositivPdf}
                      whiteSvg={LogoRogalandPrimaerNynorskEngelskNegativSvg}
                      whitePng={LogoRogalandPrimaerNynorskEngelskNegativPng}
                      whitePdf={LogoRogalandPrimaerNynorskEngelskNegativPdf}
                    />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                <LogoTableRow
                      logoUrl={LogoRogalandSekundaerBokmaalPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, bokmål"
                      text="Bokmål"
                      blackSvg={LogoRogalandSekundaerBokmaalPositivSvg}
                      blackPng={LogoRogalandSekundaerBokmaalPositivPng}
                      blackPdf={LogoRogalandSekundaerBokmaalPositivPdf}
                      whiteSvg={LogoRogalandSekundaerBokmaalNegativSvg}
                      whitePng={LogoRogalandSekundaerBokmaalNegativPng}
                      whitePdf={LogoRogalandSekundaerBokmaalNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandSekundaerBokmaalEngelskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, bokmål + engelsk"
                      text="Bokmål + engelsk"
                      blackSvg={LogoRogalandSekundaerBokmaalEngelskPositivSvg}
                      blackPng={LogoRogalandSekundaerBokmaalEngelskPositivPng}
                      blackPdf={LogoRogalandSekundaerBokmaalEngelskPositivPdf}
                      whiteSvg={LogoRogalandSekundaerBokmaalEngelskNegativSvg}
                      whitePng={LogoRogalandSekundaerBokmaalEngelskNegativPng}
                      whitePdf={LogoRogalandSekundaerBokmaalEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandSekundaerNynorskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, nynorsk"
                      text="Nynorsk"
                      blackSvg={LogoRogalandSekundaerNynorskPositivSvg}
                      blackPng={LogoRogalandSekundaerNynorskPositivPng}
                      blackPdf={LogoRogalandSekundaerNynorskPositivPdf}
                      whiteSvg={LogoRogalandSekundaerNynorskNegativSvg}
                      whitePng={LogoRogalandSekundaerNynorskNegativPng}
                      whitePdf={LogoRogalandSekundaerNynorskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoRogalandPrimaerNynorskEngelskPositivSvg}
                      title="Primærlogo: Statsforvalteren i Rogaland, nynorsk + engelsk"
                      text="Nynorsk + engelsk"
                      blackSvg={LogoRogalandSekundaerNynorskEngelskPositivSvg}
                      blackPng={LogoRogalandSekundaerNynorskEngelskPositivPng}
                      blackPdf={LogoRogalandSekundaerNynorskEngelskPositivPdf}
                      whiteSvg={LogoRogalandSekundaerNynorskEngelskNegativSvg}
                      whitePng={LogoRogalandSekundaerNynorskEngelskNegativPng}
                      whitePdf={LogoRogalandSekundaerNynorskEngelskNegativPdf}
                    />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                        logoUrl={LogoRogalandSentrertBokmaalPositivSvg}
                        title="Primærlogo: Statsforvalteren i Rogaland, bokmål"
                        text="Bokmål"
                        blackSvg={LogoRogalandSentrertBokmaalPositivSvg}
                        blackPng={LogoRogalandSentrertBokmaalPositivPng}
                        blackPdf={LogoRogalandSentrertBokmaalPositivPdf}
                        whiteSvg={LogoRogalandSentrertBokmaalNegativSvg}
                        whitePng={LogoRogalandSentrertBokmaalNegativPng}
                        whitePdf={LogoRogalandSentrertBokmaalNegativPdf}
                      />
                      <LogoTableRow
                        logoUrl={LogoRogalandSentrertBokmaalEngelskPositivSvg}
                        title="Primærlogo: Statsforvalteren i Rogaland, bokmål + engelsk"
                        text="Bokmål + engelsk"
                        blackSvg={LogoRogalandSentrertBokmaalEngelskPositivSvg}
                        blackPng={LogoRogalandSentrertBokmaalEngelskPositivPng}
                        blackPdf={LogoRogalandSentrertBokmaalEngelskPositivPdf}
                        whiteSvg={LogoRogalandSentrertBokmaalEngelskNegativSvg}
                        whitePng={LogoRogalandSentrertBokmaalEngelskNegativPng}
                        whitePdf={LogoRogalandSentrertBokmaalEngelskNegativPdf}
                      />
                      <LogoTableRow
                        logoUrl={LogoRogalandSentrertNynorskPositivSvg}
                        title="Primærlogo: Statsforvalteren i Rogaland, nynorsk"
                        text="Nynorsk"
                        blackSvg={LogoRogalandSentrertNynorskPositivSvg}
                        blackPng={LogoRogalandSentrertNynorskPositivPng}
                        blackPdf={LogoRogalandSentrertNynorskPositivPdf}
                        whiteSvg={LogoRogalandSentrertNynorskNegativSvg}
                        whitePng={LogoRogalandSentrertNynorskNegativPng}
                        whitePdf={LogoRogalandSentrertNynorskNegativPdf}
                      />
                      <LogoTableRow
                        logoUrl={LogoRogalandSentrertNynorskEngelskPositivSvg}
                        title="Primærlogo: Statsforvalteren i Rogaland, nynorsk + engelsk"
                        text="Nynorsk + engelsk"
                        blackSvg={LogoRogalandSentrertNynorskEngelskPositivSvg}
                        blackPng={LogoRogalandSentrertNynorskEngelskPositivPng}
                        blackPdf={LogoRogalandSentrertNynorskEngelskPositivPdf}
                        whiteSvg={LogoRogalandSentrertNynorskEngelskNegativSvg}
                        whitePng={LogoRogalandSentrertNynorskEngelskNegativPng}
                        whitePdf={LogoRogalandSentrertNynorskEngelskNegativPdf}
                    />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
